import React from "react";
import {  Container, StyledSelect } from "./styles";
import { Label } from "../CustomTextArea/styles";
import Spinner from "../Spinner";

export interface SelectProps {
  name?: string;
  placeholder: string;
  itemList: any;
  value:string;
  valueObjectField?:string;
  displayObjectField?:string;
  disabled?:boolean,
  onChange: (
    event:
      | React.ChangeEvent<HTMLOptionElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => void;
}

const CustomSelect = ({ name,placeholder, onChange,itemList,value,valueObjectField,displayObjectField,disabled }: SelectProps) => {
  return (
    <Container>

      {itemList && (
        <StyledSelect 
          name={name || "select"} 
          value={value} 
          onChange={onChange}
          disabled={disabled} 
          required>

            <option value={""} disabled selected hidden>{placeholder}</option>

            {itemList && (
              itemList.map((item: any) => (
                <option value={valueObjectField ? item[valueObjectField] : item}>{displayObjectField ? item[displayObjectField] : item}</option>
              ))
            )}

        </StyledSelect>
      )}

      {(itemList === undefined || itemList === null) && (
              <Spinner message=" " size="small"/>
      )}

    </Container>
  )
};

export default CustomSelect;
